import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white profile-settings-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_9 = { class: "col-md-6" };
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_11 = { class: "col-md-6" };
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_13 = { class: "col-md-6" };
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_15 = { class: "col-md-6" };
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_17 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "col-md-6" };
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_21 = {
    key: 0,
    class: "mb-3 bg-dark p-2"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = { class: "col-md-12" };
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_25 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center mb-10" };
const _hoisted_29 = { class: "text-black fw-semibold text-capitalize mb-0" };
const _hoisted_30 = { class: "form-check form-switch" };
const _hoisted_31 = ["onUpdate:modelValue"];
const _hoisted_32 = ["onUpdate:modelValue", "placeholder", "disabled"];
const _hoisted_33 = { class: "col-md-6" };
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_35 = { class: "col-md-6" };
const _hoisted_36 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_37 = { class: "col-md-6" };
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_39 = { class: "text-muted d-block mt-1" };
const _hoisted_40 = { class: "col-md-6" };
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_42 = {
    key: 0,
    class: "col-md-12 mt-3"
};
const _hoisted_43 = { class: "table-responsive" };
const _hoisted_44 = { class: "table table-bordered align-middle" };
const _hoisted_45 = { class: "fw-medium" };
const _hoisted_46 = ["onUpdate:modelValue"];
const _hoisted_47 = { class: "col-md-6" };
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_49 = { class: "col-md-6" };
const _hoisted_50 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_51 = { class: "col-md-12" };
const _hoisted_52 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_53 = { class: "col-md-12" };
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_55 = { class: "d-flex align-items-center justify-content-between p-3 border rounded bg-light" };
const _hoisted_56 = { class: "form-check form-switch pb-0 mb-0" };
const _hoisted_57 = {
    key: 0,
    class: "mt-3 p-3 border rounded bg-white"
};
const _hoisted_58 = { class: "col-md-12 mt-4 pt-4 border-top" };
const _hoisted_59 = { class: "d-flex align-items-center" };
const _hoisted_60 = ["disabled"];
const _hoisted_61 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[18] || (_cache[18] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "col-md-12 mb-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Informations de base"),
                            _createElementVNode("hr")
                        ], -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom de la Franchise", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.franchiseData.name) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: Pizza Va Bene",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.name]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Email de contact", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.franchiseData.email) = $event)),
                                    type: "email",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "info@vabenepizza.ch",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.email]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Téléphone", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.franchiseData.phoneNumber) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "+41 78 000 00 00"
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.phoneNumber]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse Complète", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.franchiseData.address) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: Rue de la Gare 12, 1003 Lausanne"
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.address]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Taux de TVA par défaut (%)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.franchiseData.tax_default_rate) = $event)),
                                    type: "number",
                                    step: "0.1",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: 2.6",
                                    onInput: _cache[5] || (_cache[5] = ($event) => (_ctx.franchiseData.tax_default_rate = Math.max(0, _ctx.franchiseData.tax_default_rate)))
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        _ctx.franchiseData.tax_default_rate,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Ce taux sera appliqué par défaut à toutes les nouvelles commandes et restaurants si non spécifié.", -1))
                            ])
                        ]),
                        _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Branding & Logos"),
                            _createElementVNode("hr")
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Logo Principal (Mode Sombre / Couleur)", -1)),
                                (_ctx.franchiseData.logo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("img", {
                                            src: _ctx.franchiseData.logo,
                                            class: "img-thumbnail",
                                            style: { "max-height": "100px" }
                                        }, null, 8, _hoisted_18)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                    type: "file",
                                    onChange: _cache[6] || (_cache[6] = ($event) => (_ctx.handleLogoChange($event, 'logo'))),
                                    class: "form-control",
                                    accept: "image/*"
                                }, null, 32)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Logo Alternatif (White / Light Mode)", -1)),
                                (_ctx.franchiseData.logo_light)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("img", {
                                            src: _ctx.franchiseData.logo_light,
                                            class: "img-thumbnail",
                                            style: { "max-height": "100px" }
                                        }, null, 8, _hoisted_22)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                    type: "file",
                                    onChange: _cache[7] || (_cache[7] = ($event) => (_ctx.handleLogoChange($event, 'logo_light'))),
                                    class: "form-control",
                                    accept: "image/*"
                                }, null, 32)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Favicon (Icône de l'onglet navigateur)", -1)),
                                (_ctx.franchiseData.favicon)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("img", {
                                            src: _ctx.franchiseData.favicon,
                                            class: "img-thumbnail",
                                            style: { "max-height": "48px" }
                                        }, null, 8, _hoisted_26)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                    type: "file",
                                    onChange: _cache[8] || (_cache[8] = ($event) => (_ctx.handleLogoChange($event, 'favicon'))),
                                    class: "form-control",
                                    accept: "image/*"
                                }, null, 32),
                                _cache[28] || (_cache[28] = _createElementVNode("small", { class: "text-muted" }, "Recommandé : PNG transparent, 32x32 ou 64x64 pixels.", -1))
                            ])
                        ]),
                        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Réseaux Sociaux"),
                            _createElementVNode("hr")
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.franchiseData.social_links, (social, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: key,
                                class: "col-md-6"
                            }, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("label", _hoisted_29, _toDisplayString(key), 1),
                                        _createElementVNode("div", _hoisted_30, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event) => ((social.active) = $event)
                                            }, null, 8, _hoisted_31), [
                                                [_vModelCheckbox, social.active]
                                            ]),
                                            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-check-label small ms-1" }, "Activé", -1))
                                        ])
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event) => ((social.url) = $event),
                                        type: "url",
                                        class: "form-control shadow-none rounded-0 text-black",
                                        placeholder: 'Lien ' + key,
                                        disabled: !social.active
                                    }, null, 8, _hoisted_32), [
                                        [_vModelText, social.url]
                                    ])
                                ])
                            ]));
                        }), 128)),
                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Configuration Marketing (Emails)"),
                            _createElementVNode("hr"),
                            _createElementVNode("p", { class: "text-muted small mb-4" }, "Ces informations seront utilisées comme expéditeur lors de l'envoi de vos campagnes.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Email de l'expéditeur", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.marketingData.mailjet_sender_email) = $event)),
                                    type: "email",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: newsletter@vabenepizza.ch"
                                }, null, 512), [
                                    [_vModelText, _ctx.marketingData.mailjet_sender_email]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom de l'expéditeur", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.marketingData.mailjet_sender_name) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: Pizza Va Bene"
                                }, null, 512), [
                                    [_vModelText, _ctx.marketingData.mailjet_sender_name]
                                ])
                            ])
                        ]),
                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Cross-Sell & Recommandations"),
                            _createElementVNode("hr"),
                            _createElementVNode("p", { class: "text-muted small mb-4" }, "Configurez l'intelligence artificielle qui propose des produits complémentaires à vos clients.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Algorithme de recommandation", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.franchiseData.upsell_settings.algorithmId) = $event)),
                                    class: "form-select shadow-none rounded-0 text-black"
                                }, [...(_cache[32] || (_cache[32] = [
                                        _createElementVNode("option", { value: 1 }, "Mode 1 : Fréquemment achetés ensemble (Historique global)", -1),
                                        _createElementVNode("option", { value: 2 }, "Mode 2 : Habitudes clients (Historique personnel)", -1),
                                        _createElementVNode("option", { value: 3 }, "Mode 3 : Règles simples (Basé sur les catégories)", -1),
                                        _createElementVNode("option", { value: 4 }, "Mode 4 : Hybride Intégré (Optimisé par IA)", -1)
                                    ]))], 512), [
                                    [_vModelSelect, _ctx.franchiseData.upsell_settings.algorithmId]
                                ]),
                                _createElementVNode("small", _hoisted_39, _toDisplayString(_ctx.getAlgoDescription(_ctx.franchiseData.upsell_settings.algorithmId)), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Limite de produits (Cross-sell)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.franchiseData.upsell_settings.limit) = $event)),
                                    type: "number",
                                    min: "3",
                                    max: "9",
                                    class: "form-control shadow-none rounded-0 text-black"
                                }, null, 512), [
                                    [
                                        _vModelText,
                                        _ctx.franchiseData.upsell_settings.limit,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                _cache[35] || (_cache[35] = _createElementVNode("small", { class: "text-muted" }, "Nombre max de produits suggérés dans le panier (standard: 6).", -1))
                            ])
                        ]),
                        (_ctx.uniqueCategoryNames.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mapping des catégories pour l'IA", -1)),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("table", _hoisted_44, [
                                        _cache[37] || (_cache[37] = _createElementVNode("thead", { class: "bg-light" }, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", { style: { "width": "50%" } }, "Nom de la catégorie (tous restaurants)"),
                                                _createElementVNode("th", null, "Type pour recommandation")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueCategoryNames, (catName) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: catName }, [
                                                    _createElementVNode("td", _hoisted_45, _toDisplayString(catName), 1),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": ($event) => ((_ctx.franchiseData.upsell_settings.categoryMapping[catName]) = $event),
                                                            class: "form-select form-select-sm border-0 bg-light"
                                                        }, [...(_cache[36] || (_cache[36] = [
                                                                _createStaticVNode("<option value=\"other\" data-v-fee84376>Autre / Inconnu</option><option value=\"pizza\" data-v-fee84376>Pizza / Plat Principal</option><option value=\"pasta\" data-v-fee84376>Pasta / Accompagnement</option><option value=\"starter\" data-v-fee84376>Entrée / Starter</option><option value=\"drink\" data-v-fee84376>Boisson</option><option value=\"dessert\" data-v-fee84376>Dessert</option>", 6)
                                                            ]))], 8, _hoisted_46), [
                                                            [_vModelSelect, _ctx.franchiseData.upsell_settings.categoryMapping[catName]]
                                                        ])
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]),
                                _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-muted small" }, "L'IA utilise ces tags pour ne pas proposer une pizza à quelqu'un qui commande déjà une pizza, mais plutôt une boisson ou un dessert.", -1))
                            ]))
                            : _createCommentVNode("", true),
                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "SEO & Analytiques (Site Web)"),
                            _createElementVNode("hr"),
                            _createElementVNode("p", { class: "text-muted small mb-4" }, "Configurez le référencement et le suivi de performance pour le site web de votre franchise.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Google Analytics 4 ID (G-XXXX)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.franchiseData.google_analytics_id) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "ex: G-12345678"
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.google_analytics_id]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Bing Webmaster ID (Verification Code)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.franchiseData.bing_webmaster_id) = $event)),
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black"
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.bing_webmaster_id]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Meta Description (Moteurs de recherche)", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.franchiseData.meta_description) = $event)),
                                    class: "form-control shadow-none rounded-0 text-black",
                                    rows: "3",
                                    placeholder: "Description apparaissant sous votre nom dans Google..."
                                }, null, 512), [
                                    [_vModelText, _ctx.franchiseData.meta_description]
                                ]),
                                _cache[43] || (_cache[43] = _createElementVNode("small", { class: "text-muted" }, "Recommandé : entre 150 et 160 caractères.", -1))
                            ])
                        ]),
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                            _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Intégrations Externes"),
                            _createElementVNode("hr")
                        ], -1)),
                        _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                    _cache[44] || (_cache[44] = _createElementVNode("div", null, [
                                        _createElementVNode("h6", { class: "mb-1 text-black" }, "WhatsApp Business"),
                                        _createElementVNode("p", { class: "mb-0 text-muted small" }, "Activer le bouton de contact direct WhatsApp sur le site web pour tous les restaurants.")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_56, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input ms-0",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.franchiseData.is_whatsapp_enabled) = $event)),
                                            style: { "width": "3em", "height": "1.5em", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.franchiseData.is_whatsapp_enabled]
                                        ])
                                    ])
                                ]),
                                (_ctx.franchiseData.is_whatsapp_enabled)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                        _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro WhatsApp Business", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.franchiseData.whatsapp_number) = $event)),
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "ex: +41781234567"
                                        }, null, 512), [
                                            [_vModelText, _ctx.franchiseData.whatsapp_number]
                                        ]),
                                        _cache[46] || (_cache[46] = _createElementVNode("small", { class: "text-muted" }, "Entrez le numéro au format international (avec le +).", -1))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("button", {
                                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 bg-success",
                                    type: "submit",
                                    disabled: _ctx.isSaving
                                }, [
                                    (_ctx.isSaving)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                                        : _createCommentVNode("", true),
                                    _cache[47] || (_cache[47] = _createTextVNode(" Enregistrer les modifications ", -1))
                                ], 8, _hoisted_60)
                            ])
                        ])
                    ])
                ], 32))
        ])
    ]));
}
